import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import MethodSection from './components/MethodSection';
import GalleryPreview from './components/GalleryPreview';
import MythSection from './components/MythSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <MethodSection />
        <MythSection />
        <GalleryPreview />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}